import type { LearnerSearchMixpanelEvents } from '../../constants/mixpanel';
import { TagField } from '@workramp/ui';
import { I18n } from '~/common/explicit-exports';
import { MixPanel } from '~/common';

const stringToObjectFieldItem = (object: string) => ({ name: object, key: object });

interface AdvancedSearchFilterModalAutocompleteFilterProps<T> {
  selectedObjects: string[];
  setSelectedObjects: (objects: string[]) => void;
  availableObjects: T[];
  setObjectSearchTerm: (term: string) => void;
  objectSearchTerm: string;
  mixpanelEvent: `${LearnerSearchMixpanelEvents}`;
  isDisabled?: boolean;
}

export const AdvancedSearchFilterModalAutocompleteFilter = <T extends { name: string }>({
  selectedObjects,
  setSelectedObjects,
  availableObjects,
  setObjectSearchTerm,
  objectSearchTerm,
  mixpanelEvent,
  isDisabled = false,
}: AdvancedSearchFilterModalAutocompleteFilterProps<T>) => {
  const SEARCH = I18n.t('js.learner.advanced_search.filters.search');

  const handleSelectionChange = (
    newObjects: {
      name: string;
      key: string;
    }[],
  ) => {
    setSelectedObjects(newObjects.map((t) => t.name));
    setObjectSearchTerm('');
    MixPanel.track(mixpanelEvent);
  };

  return (
    <TagField
      onSelectionChange={handleSelectionChange}
      inputValue={objectSearchTerm}
      items={availableObjects.map(({ name }) => stringToObjectFieldItem(name))}
      isDisabled={isDisabled || (!availableObjects.length && !objectSearchTerm)}
      hideLabel
      label=""
      onInputChange={setObjectSearchTerm}
      placeholder={SEARCH}
      selectedOptions={selectedObjects.map((t) => stringToObjectFieldItem(t))}
    >
      {(item) => <TagField.Item key={item.key}>{item.name}</TagField.Item>}
    </TagField>
  );
};
